
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const EnglishInfoPage = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-5xl">
      <Helmet>
        <title>Information | Lainasampo</title>
        <meta name="description" content="Important information about our loan services and legal terms in English." />
      </Helmet>

      <div className="mb-8">
        <h1 className="text-4xl font-bold text-primary mb-4">Important Information</h1>
        <p className="text-lg text-gray-600">
          This page contains important information about our services and legal documents in English.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Terms of Service</h2>
          <p className="mb-6">
            Our terms of service explain the conditions for using our loan comparison services,
            including your rights and responsibilities.
          </p>
          <Link to="/en/terms">
            <Button variant="outline" className="w-full">View Terms of Service</Button>
          </Link>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Privacy Policy</h2>
          <p className="mb-6">
            Our privacy policy details how we handle your personal information,
            including what we collect and how we use it.
          </p>
          <Link to="/en/privacy">
            <Button variant="outline" className="w-full">View Privacy Policy</Button>
          </Link>
        </div>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg mb-12">
        <h2 className="text-2xl font-bold mb-4">Customer Support</h2>
        <p className="mb-4">
          If you have any questions about our services or need assistance,
          our customer support team is available to help you.
        </p>
        <p className="mb-4">
          Email: <a href="mailto:info@lainasampo.fi" className="text-primary hover:underline">info@lainasampo.fi</a>
        </p>
        <div className="flex flex-wrap gap-4 mt-6">
          <Link to="/english">
            <Button variant="secondary">Back to English Home</Button>
          </Link>
          <Link to="/english/apply">
            <Button>Apply for a Loan</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EnglishInfoPage;
